import template from './service_tickets.html';
import controller from './service_tickets.controller';
import './service_tickets.scss';

let serviceTicketsComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default serviceTicketsComponent;


// WEBPACK FOOTER //
// ./client/app/components/service_tickets/service_tickets.component.js